import { render, staticRenderFns } from "./FAQList.vue?vue&type=template&id=edd34564&scoped=true"
import script from "./FAQList.vue?vue&type=script&lang=js"
export * from "./FAQList.vue?vue&type=script&lang=js"
import style0 from "./FAQList.vue?vue&type=style&index=0&id=edd34564&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd34564",
  null
  
)

export default component.exports